import { render, staticRenderFns } from "./CreateReleases.vue?vue&type=template&id=1473396b&scoped=true"
import script from "./CreateReleases.vue?vue&type=script&lang=js"
export * from "./CreateReleases.vue?vue&type=script&lang=js"
import style0 from "./CreateReleases.vue?vue&type=style&index=0&id=1473396b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473396b",
  null
  
)

export default component.exports